import { PathMatch, useMatch } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

type UseOnboardingCompanySteps = {
  /* ** Current step number ** */
  progress: number;
  /* ** Available steps ** */
  activeSteps: {
    label: string;
    value: PathMatch<string> | null;
  }[];
};

/**
 * useOnboardingSteps.
 * Build available steps depending on the onboarding company.
 * `activeSteps` looks for the first PathMatch, that is the current step from the URL.
 *
 * @returns {UseFundraisingSteps}
 */
export function useOnboardingSteps(): UseOnboardingCompanySteps {
  //TODO: rename Wizard suffixe
  const i18nOnboardingExistingCompanyWizard = useTranslations('OnboardingExistingCompanyWizard');

  const onboardingsCompanyRoutes = routes.onboardings.company;

  const isCreateActive = useMatch(onboardingsCompanyRoutes.create.href);
  const isParameters = useMatch(onboardingsCompanyRoutes.infos.href);
  const isRepresentativesActive = useMatch(onboardingsCompanyRoutes.representatives.href);
  const isOwnersActive = useMatch(onboardingsCompanyRoutes.owners.href);
  const isAccessActive = useMatch(onboardingsCompanyRoutes.access.href);
  const isSummaryActive = useMatch(onboardingsCompanyRoutes.summary.href);

  const activeSteps = [
    {
      label: i18nOnboardingExistingCompanyWizard('CompanyInformationsStep'),
      value: isCreateActive || isParameters,
    },
    {
      label: i18nOnboardingExistingCompanyWizard('RepresentantInformationsStep'),
      value: isRepresentativesActive,
    },
    {
      label: i18nOnboardingExistingCompanyWizard('ShareholderInformationsStep'),
      value: isOwnersActive,
    },
    { label: i18nOnboardingExistingCompanyWizard('OtherRoleStep'), value: isAccessActive },
    { label: i18nOnboardingExistingCompanyWizard('SummaryStep'), value: isSummaryActive },
  ];

  const progress = activeSteps.findIndex((v) => v.value);

  return { progress, activeSteps };
}
